/*
 * @Author: Tina Huang
 * @Date: 2024-03-05 11:01:08
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:41:38
 * @Description: 伪后台页面
 */
import { Picks } from '@/constants/picks'
import { Image, Button, message, Input, Tag, DatePicker, Form, Radio, Affix } from 'antd'
import { useEffect, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

export default function Admin() {
  const _picks = Picks.filter((item) => item.link || item.rlink)
  const localhost = window.location
  const [messageApi, contextHolder] = message.useMessage()
  const [picksOptions, setPicksOptions] = useState<any[]>([])
  const [targetItem, setTargetItem] = useState<any>(null)
  const [targetLink, setTargetLink] = useState<string>('')
  const [targetDesc, setTargetDesc] = useState<string>('')
  const [pass, setPass] = useState(localStorage?.pass === 'true')

  const [formRef] = Form.useForm()

  // const itemRef = useRef()

  useEffect(() => {
    let _list: any[] = []
    _picks.map((item) => {
      _list.push({
        value: item.id,
        label: (
          <>
            {item?.hide && <Tag color="yellow">隐藏</Tag>}
            {item.title}
          </>
        ),
        hide: item?.hide,
      })
      return null
    })
    setPicksOptions([..._list])
  }, [_picks])

  const handleChange = (e: any) => {
    const _id = e.target.value
    const _item: any = _picks.find((current) => current.id === _id)
    setTargetItem(_item)
    setTemplateLink(_item)
  }

  const handleDateChange = () => {
    setTemplateLink(targetItem)
  }

  const getLinkId = (item: any) => {
    const _id = (item?.rlink || item?.link)?.replace('https://httishere666.notion.site/', '')
    const _spits = _id.split('?')[0]
    return _spits
  }

  const setTemplateLink = (item: any) => {
    console.log('update')
    const _ex = new Date(formRef.getFieldValue('expired'))?.getTime()
    const _linkId = getLinkId(item)
    const code = item?.code
    const _time = _ex || new Date().getTime() + 604800000
    const state = {
      id: item.id,
      link: _linkId,
      code,
      time: _time,
    }
    const _link = `${localhost.origin}${localhost.pathname}#/get-template/${encodeURIComponent(window.btoa(JSON.stringify(state)))}`
    setTargetLink(_link)
    setTargetDesc(
      `${item.title}:\n\n${_link}\n\n✅ 模板拷贝方法：复制上述链接在浏览器打开，点击「拷贝按钮」拷贝到自己空间\n\n❗️ 请及时拷贝模板避免过期`
    )
  }

  const handleCopy = () => {
    if (targetLink) return messageApi.success('拷贝成功')
  }
  const handlePassCode = (e: any) => {
    if (e.target.value === '960728') {
      setPass(true)
      localStorage.pass = true
    }
  }

  return (
    <div>
      {contextHolder}
      {!pass && (
        <>
          <Input placeholder="pass code" onChange={handlePassCode} />
        </>
      )}
      {pass && (
        <Form form={formRef}>
          <h1 className="text-xl text-center font-bold mb-4">创建模板获取链接(默认7天有效期)</h1>
          <Affix offsetTop={110}>
            <CopyToClipboard text={targetDesc} onCopy={handleCopy}>
              <Button type="primary" danger block shape="round" className="my-8">
                复制模板说明
              </Button>
            </CopyToClipboard>
          </Affix>
          <Form.Item name="expired" label="过期时间">
            <DatePicker className="w-full" onChange={handleDateChange} />
          </Form.Item>
          <Form.Item name="template" label="相关模板">
            <Radio.Group options={picksOptions} onChange={handleChange} optionType="button" buttonStyle="solid" size="large" />
            {/* <Select
              className="w-full"
              options={picksOptions}
              optionRender={(option) => (
                <>
                  {option.data?.hide && <Tag color="yellow">隐藏模板</Tag>}
                  {option.label}
                </>
              )}
              placeholder="选择创建的模板"
              onChange={handleChange}
            /> */}
          </Form.Item>
          <div className="pt-4">
            {/* <p>{targetDesc}</p> */}
            <CopyToClipboard text={targetLink} onCopy={handleCopy}>
              <Button type="primary" block shape="round" className="mt-8">
                复制模板链接
              </Button>
            </CopyToClipboard>

            <Input.TextArea placeholder="粘贴预览" rows={10} autoSize={{ maxRows: 15 }} className="mt-5 mb-5" />
            <Image src={targetItem?.cover} />
          </div>
        </Form>
      )}
    </div>
  )
}
